import { render, staticRenderFns } from "./TeamNews.vue?vue&type=template&id=a0d887de&scoped=true"
import script from "./TeamNews.vue?vue&type=script&lang=js"
export * from "./TeamNews.vue?vue&type=script&lang=js"
import style0 from "./TeamNews.vue?vue&type=style&index=0&id=a0d887de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d887de",
  null
  
)

export default component.exports